import { Shell } from "@commerce/components/Shell";
import { TimeZoneProvider } from "@commerce/components/time";
import { AppNotFound } from "@saas/shared/components/AppNotFound";
import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { getSidebarOpenFn, getTimeZoneFn } from "~/server/ui";

export const Route = createFileRoute("/_saas/app")({
	beforeLoad: ({ context }) => {
		const { session, organizations } = context;

		// Retailer staff always belong to a retailer. Someone signed in without
		// one (an invitation withdrawn after signup) gets told how to get in.
		const organization =
			organizations?.find(
				(org) => org.id === session.session.activeOrganizationId,
			) ?? organizations?.[0];
		if (!organization && session.user.role !== "admin") {
			throw redirect({ to: "/new-organization" });
		}

		return { session, organizations };
	},
	// The sidebar cookie only changes when the user toggles it on this device.
	loader: async () => ({
		sidebarOpen: await getSidebarOpenFn(),
		timeZone: await getTimeZoneFn(),
	}),
	staleTime: Number.POSITIVE_INFINITY,
	component: AppLayout,
	notFoundComponent: AppLayoutNotFound,
});

function AppLayoutNotFound() {
	const data = Route.useLoaderData();
	return (
		<TimeZoneProvider timeZone={data?.timeZone ?? "UTC"}>
			<Shell defaultSidebarOpen={data?.sidebarOpen}>
				<AppNotFound />
			</Shell>
		</TimeZoneProvider>
	);
}

function AppLayout() {
	const { sidebarOpen, timeZone } = Route.useLoaderData();
	return (
		<TimeZoneProvider timeZone={timeZone}>
			<Shell defaultSidebarOpen={sidebarOpen}>
				<Outlet />
			</Shell>
		</TimeZoneProvider>
	);
}
